;(function() {

    jQuery(document).ready(function($) {

        // Hamburger animation
        $('.js-hamburger-toggle').on('click', function() {
			$('.js-hamburger-toggle').toggleClass('is-active');

            $('body, html').toggleClass('js-nav-open');
            return false;
        });

        // Mobile menu
        $('.navigation--mobile .menu-item-has-children').append('<div class="menu-arrow"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#000" stroke-width="2"/></svg></div>');
        $('.navigation--mobile .menu-arrow').click(function () {
            $(this).parent().toggleClass('is-active');
        });
	});
}());
